import { render, staticRenderFns } from "./PatientDetailImageDescriptionOrigin.vue?vue&type=template&id=da53b8ca&scoped=true&"
import script from "./PatientDetailImageDescriptionOrigin.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailImageDescriptionOrigin.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailImageDescriptionOrigin.vue?vue&type=style&index=0&id=da53b8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53b8ca",
  null
  
)

export default component.exports